import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';
import { VARIANT } from 'features/high-demand/shared/consts';

export default makeStyles({
  section: {
    marginBottom: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    color: neutral['100'],
  },
  alert: {
    padding: '0.5rem',
    borderRadius: '0.5rem',
    border: `1px solid ${VARIANT.fastFromOCC.color}`,
    color: VARIANT.fastFromOCC.color,
    backgroundColor: VARIANT.fastFromOCC.bgColor,
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },
  divTitle: {
    marginBottom: '0.5rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    letterSpacing: '0.12em',
    color: neutral['50'],
  },
  divParagraph: {
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
});
